import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import styled from 'styled-components/macro'

const UserDropdownMenuComponent = React.lazy(() => loadComponent('orga', 'UserDropdownMenu'))

const StyledDiv = styled.div``

export function UserDropdownMenu() {
    const navigate = useNavigate()

    const onLogout = useCallback(() => {
        navigate('/login')
    }, [navigate])

    const onOpenProfile = useCallback(() => {
        navigate('/profile')
    }, [navigate])

    return (
        <StyledDiv>
            <UserDropdownMenuComponent onLogout={onLogout} onOpenProfile={onOpenProfile} />
        </StyledDiv>
    )
}
